import { rootApi } from '../rootApi';

const mapArrayToQueryParams = (baseKey, items, mappingFn) => {
  const params = {};
  items?.forEach((item, index) => {
    const mapped = mappingFn(item);
    Object.keys(mapped).forEach((key) => {
      params[`${baseKey}[${index}].${key}`] = mapped[key];
    });
  });
  return params;
};

export const laborCatalogApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLaborCatalog: builder.query({
           query: ({ pageNumber, pageSize,carItemCode,model,createdDate,productGroup}) => {
                const queryParams = {
                    PageNumber: pageNumber !== undefined ? pageNumber :0,
                    PageSize: pageSize || 10
                };

                 if (carItemCode) {
                    queryParams.CarItemCode = carItemCode;
                }

                 if (model) {
                    queryParams.model = model;
                }

                 if (createdDate) {
                    queryParams.createdDate = createdDate;
                }
                 if (productGroup) {
                    queryParams.productGroup = productGroup;
                }
                


                return {
                    url: 'v1/warrantylabor',
                    method: 'GET',
                    params: queryParams
                };
            },
            

             transformResponse: (response) => {
                if (response && typeof response === 'object') {
                    if (response.data && Array.isArray(response.data.items)) {
                        return response.data;
                    }
                    if (Array.isArray(response.items)) {
                        return response;
                    }
                }
                return { items: [], totalCount: 0 };
            },

            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled;
                } catch (error) {
                    console.error('❌ getLaborCatalog - Query Failed:', error);
                }
            },
            providesTags: ['LaborCatalog']
        }),

        getLaborCatalogById: builder.query({
            query: (params) => ({
                url: `v1/warrantylabor/getbyid`,
                method: 'GET',
                params: {
                    id: params.id,
                    LanguageId: params?.languageId || 1
                }
            }),
            transformResponse: (response) => {
                if (response.isSuccessful && response.data) {
                    return response;
                }
                return { data: null };
            },
            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled;
                } catch (error) {
                    console.error('❌ getLaborCatalogById - Query Failed:', error);
                }
            }
        }),

        createLaborCatalog: builder.mutation({
            query: (data) => {
                const payload = {
                    startDate: data.startDate,
                    endDate: data.endDate,
                    productGroup: data.productGroup,
                    model: data.model,
                    carItemCode: data.carItemCode,
                    laborGroup: data.laborGroup,
                    status: data.status,
                    laborCode: data.laborCode,
                    laborTime: data.laborTime,
                    isActive: data.isActive,
                    translations: data.translations
                };

                return {
                    url: 'v1/warrantylabor',
                    method: 'POST',
                    body: payload
                };
            },
            transformResponse: (response) => {
                if (response.isSuccessful) {
                    return {
                        isSuccessful: true,
                        data: response.data
                    };
                }
                return {
                    isSuccessful: false,
                    errorMessage: response.errorMessage || 'Bir hata oluştu'
                };
            },
            invalidatesTags: ['LaborCatalog']
        }),

        updateLaborCatalog: builder.mutation({
            query: (data) => {
                const payload = {
                    id: data.id,
                    startDate: data.startDate,
                    endDate: data.endDate,
                    productGroup: data.productGroup,
                    model: data.model,
                    carItemCode: data.carItemCode,
                    laborGroup: data.laborGroup,
                    status: data.status,
                    laborCode: data.laborCode,
                    laborTime: data.laborTime,
                    isActive: data.isActive,
                    translations: data.translations
                };

                return {
                    url: 'v1/warrantylabor',
                    method: 'PATCH',
                    body: payload
                };
            },
            transformResponse: (response) => {
                if (response.isSuccessful) {
                    return {
                        isSuccessful: true,
                        data: response.data
                    };
                }
                return {
                    isSuccessful: false,
                    errorMessage: response.errorMessage || 'Bir hata oluştu'
                };
            },
            invalidatesTags: ['LaborCatalog']
        }),

        deleteLaborCatalog: builder.mutation({
            query: (Id) => ({
                url: `v1/warrantylabor`,
                method: 'DELETE',
                body: { Id }
            }),

            invalidatesTags: ['LaborCatalog']
        }),
        
        getLaborCatalogReport: builder.query({
      query: (params) => {

         // 1. Varsayılan değerlerle temel objeyi oluştur
        let queryParams = {
          PageNumber: params?.pageNumber ?? 1,
          PageSize: params?.pageSize ?? 10,
          LanguageId: params?.languageId ?? 1,
          IncludeFilterOptions: params?.includeFilterOptions ?? false,
        };

        // 2. Dinamik Filtreleri ekle
        if (params?.filters?.length > 0) {
          Object.assign(queryParams, mapArrayToQueryParams('Filters', params.filters, (f) => ({
            Column: f.column,
            Operator: f.operator,
            Value: f.value
          })));
        }

        // 3. Dinamik Sıralamaları ekle
        if (params?.sorts?.length > 0) {
          Object.assign(queryParams, mapArrayToQueryParams('Sorts', params.sorts, (s) => ({
            Column: s.column,
            Direction: s.direction
          })));
        }

        // 4. Filtre kolonlarını ekle s
        params?.filterOptionsColumns?.forEach((col, index) => {
          queryParams[`FilterOptionsColumns[${index}]`] = col;
        });
        
        return {
          url: 'v1/laborcatalog/getallreport',
          method: 'GET',
          params: queryParams,
        };
      },
      transformResponse: (response) => {
        if (response?.data) {
          return { 
            items: response.data.items ?? [], 
            totalCount: response.data.totalCount ?? 0,
            filterOptions: response.data.filterOptions ?? null
          };
        }
        return { items: [], totalCount: 0, filterOptions: null };
      },
      providesTags: ['LaborCatalogReport'],
    }),
    exportLaborCatalogReportToExcel: builder.query({
    query: (body) => ({
        url: 'v1/laborcatalog/exporttoexcel',
        method: 'POST',
        body: {
            languageId: body.languageId ?? 1,
            filters: body.filters ?? null,
            sorts: body.sorts ?? null,
            compressionType: body.compressionType ?? 1,
        },
    }),
    transformResponse: (response) => {
        if (response?.isSuccessful && response?.data) {
            const { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType } = response.data;
            return { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType };
        }
        throw new Error(response?.errorMessage || 'Export failed');
    }
   }),
 })
});

export const { useGetLaborCatalogQuery, useGetLaborCatalogByIdQuery, useCreateLaborCatalogMutation, useUpdateLaborCatalogMutation, useDeleteLaborCatalogMutation, useGetLaborCatalogReportQuery ,useLazyExportLaborCatalogReportToExcelQuery } = laborCatalogApi;
